<template>
    <section class="top-menu">
        <div>
            <b-nav tabs ref="topMenu">
                <b-nav-item :to="{name: 'alert'}" :active="this.$router.currentRoute.name == 'alert'">Сообщения</b-nav-item>
                <b-nav-item :to="{name: 'alertConfig'}" :active="this.$router.currentRoute.name == 'alertConfig'">Конфигурация</b-nav-item>
            </b-nav>
        </div>
    </section>
</template>

<script>
    export default {
        name: "alertTopMenu"
    }
</script>

<style scoped>
    .top-menu {
        margin-bottom: 20px;
    }
</style>